import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { apiBaseAddress } from '../../config'
import { imageLoaderForStaticImages } from '../../context/utils'
import ColoredDivider from '../coloredDivider.component'
import contrastIcon from "../../public/header/High_contrast_icon.svg";
import { useRouter } from 'next/router'
import { useAppContext } from '../../context/siteMapContext'

const Toolbar = () => {
  const router = useRouter();
  const { highContrastOn, setHighContrastOn } = useAppContext()

  const toggleHighContrastModel = () => {
    setHighContrastOn(!highContrastOn);
  }

  return (
    <>
      <div className='w-full flex flex-col sm:flex-row items-end gap-6 2xl:gap-10 sm:items-center pr-12'>
        <Link href={apiBaseAddress} shallow>
          <a className='hidden 2xl:inline-block order-1'>BELÉPÉS</a>
        </Link>
        <Link href='/imprint' as={'impresszum'} shallow>
          <a className='order-2'>KAPCSOLAT</a>
        </Link>
        <Link href='https://hirlevel.bp18.hu'>
          <a className='order-3'>HÍRLEVÉL</a>
        </Link>
        <div className='order-4 2xl:order-4 cursor-pointer flex' tabIndex={0}>
          <span onClick={toggleHighContrastModel}>
            <Image
              src={contrastIcon}
              title='Megjelenítés gyengénlátóknak'
              alt='Megjelenítés gyengénlátóknak'
              loader={imageLoaderForStaticImages}
              height={18}
              width={18}
            />
          </span>
        </div>
      </div>
      <div className='z-2 relative h-[3px] w-full my-4 2xl:my-8 bg-white'>
        {!highContrastOn && <ColoredDivider />}
      </div>
    </>
  )
}

export default Toolbar
